<template>
    <div>
        <article class="cardArticle">
            <main class="cardMain">
                 <!--S 检索-->
                <el-form :model="searchRecordForm" inline class="searchForm operateForm" @submit.native.prevent>
                    <!-- <el-form-item label="派单人">
                        <el-input clearable v-model="searchRecordForm.desuname" placeholder="请输入内容"></el-input>
                    </el-form-item> -->
                    <el-form-item label="订单号" class="codeSerIpt">
                        <el-input clearable v-model="searchRecordForm.orderno" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item label="派单时间">
                        <el-date-picker v-model="searchRecordForm.outBoundDate" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>
                   <!--  <el-form-item label="接受/拒绝派单时间">
                        <el-date-picker v-model="searchRecordForm.outBoundDates" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item> -->
                    <el-form-item label="二级门店">
                      <span class="selectIpt" :class="{'greyColor':!searchRecordForm.flowname}" @click="shipperShow = true">{{searchRecordForm.flowname?searchRecordForm.flowname:'请选择二级门店'}} 
                        <i class="iconright"></i>
                        <i class="el-icon-circle-close" v-show="searchRecordForm.flowcode" @click.stop="searchRecordForm.flowcode = '';searchRecordForm.flowname = '' "></i>
                      </span>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="query">查询</el-button>
                    </el-form-item>
                </el-form>
                <!-- E 检索 -->
                <section>
                    <el-table ref="gsTable" class="comTable recordTable" border :data="cardBatchList" v-loading="vloading"  :maxHeight="tableHeight">
                        <el-table-column fixed label="序号" type="index"></el-table-column>
                        <el-table-column label="订单号" min-width="230" fixed  prop="operdate">
                           <template slot-scope="scope">
                               {{scope.row.orderno}}
                            </template>
                        </el-table-column>
                        <el-table-column label="派单状态" min-width="150" fixed  prop="flowname">
                             <template slot-scope="scope">
                                <p class="textHiden orangeColor" v-if="scope.row.desstate==0">未派单</p>
                                <p class="textHiden blueColor" v-if="scope.row.desstate==1">派单完成</p>
                                <p class="textHiden redColor" v-if="scope.row.desstate==2">派单退回</p>
                                <p class="textHiden greyColor" v-if="scope.row.desstate==3">派单取消</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="派单时间" min-width="200"  prop="opernum" fixed>
                            <template slot-scope="scope">
                                 <p class="textHiden"> {{dateTime(scope.row.desdate,1)}}</p>
                            </template>
                        </el-table-column>
												<el-table-column label="接受/拒绝派单时间" min-width="200"  prop="opernum" fixed>
												    <template slot-scope="scope">
												         <p class="textHiden"> {{dateTime(scope.row.recdate,1)}}</p>
												    </template>
												</el-table-column>
                        <el-table-column label="派单人" min-width="180">
                            <template slot-scope="scope">
                                <p class="textHiden" :title="scope.row.desuname">{{scope.row.desuname || '--'}}</p>
                            </template>
                        </el-table-column>
												<el-table-column label="受派方" min-width="200">
												    <template slot-scope="scope">
												        <p class="textHiden" :title="scope.row.recuname">{{scope.row.recuname || '--'}}</p>
												    </template>
												</el-table-column>
												<template slot="empty" v-if="vloading">
													<div :class="{noData:vloading}"></div>
												</template>
                        <template slot="empty" v-else>
                          <div class="noData"><span>暂无数据</span></div>
                        </template>
                    </el-table>
                    <!-- S 分页 -->
                    <Page :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
                    <!-- E 分页 -->
                </section>
            </main>
        </article>
        <FlowPop objtype="9" :typename="1" :flowcode='searchRecordForm.flowcode' :shipperShow="shipperShow" @closeFlowPop="closeFlowPop"></FlowPop>
    </div>
</template>
<script>
import Api from "@/apis/api.js";
import { mapState, mapActions } from "vuex";
export default {
    name:'EjmdOrdersProcessed',
    components: {
      Page: resolve => require(["@/components/common/Page.vue"], resolve),//分页
      FlowPop: resolve => require(["@/components/common/FlowPop.vue"], resolve),
    },
    data(){
        return{
            flowname:'',
            flowcode:'',
            shipperShow:false,
			      vloading:false,
            flowList:[],
            memberList:[],
            types:0,
            batchcode:'',
            num:0,
            pageTotal:0, //总数
            currentPage:1, // 页数
            pageSize:30, // 条数
            cardBatchList:[],
            batchOtherOper:'',
            // 检索表单  
            searchRecordForm:{
                orderno:'',//订单号
                outBoundDate:'', //派单时间
                flowcode:'',
                flowname:'',
				// outBoundDates:'', // 拒绝派单时间
                // desuname:'', // 派单人
                // desstate:'',//派单状态
            },
             //选择时间
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            highShow:false,//是否展示高级筛选
            recoverMemo:'',//操作类弹框备注
            recoverDialogVisible:false,//操作类弹框
            coverSuccessDialogVisible:false,//操作类成功弹框
            tableHeight: window.innerHeight*.8, //表格动态高度
            operateTxt:'',//弹框类型文字
        }
    },
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
    // ==================================== 方法 ====================================
    methods:{
      closeFlowPop(data){
         if(data){
          this.searchRecordForm.flowcode = data.flowcode
          this.searchRecordForm.flowname = data.flowname
         }
         this.shipperShow = false
      },
        //查询
        query(){
          this.pageSize =30;
          this.currentPage =1;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchList();
        },
        // 分页
        nowPageParam(val,vals){
          this.pageSize = val;
          this.currentPage = vals;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchList();
        },
        //动态获取表格高度
        getHeight() {
        let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
        //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
        this.tableHeight = window.innerHeight - tbHeight - 125; 
        },
        getCardBatchList(){
		   this.vloading = true;
           let param = {
                orderno:this.searchRecordForm.orderno,
                startDesdate:this.searchRecordForm.outBoundDate?this.dateTime(this.searchRecordForm.outBoundDate[0]):'',
                endDesdate:this.searchRecordForm.outBoundDate?this.dateTime(this.searchRecordForm.outBoundDate[1]):'',
                recucode: this.searchRecordForm.flowcode,
                // startRecvdate:this.searchRecordForm.outBoundDates?this.dateTime(this.searchRecordForm.outBoundDates[0]):'',
                // endRecvdate:this.searchRecordForm.outBoundDates?this.dateTime(this.searchRecordForm.outBoundDates[1]):'',
                // desuname:this.searchRecordForm.desuname,
                // desstate:this.searchRecordForm.desstate?Number(this.searchRecordForm.desstate):'',
                pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
                }
           }
           Api.GET_ORDERDESINFORECORDLIST(param).then(res =>{
                if(res.data.status=="200"){
                    this.vloading =false;
                    this.cardBatchList = res.data.data;
                    this.pageTotal = res.data.pagebean.totalnum;
                }else {
                    this.vloading =false;
                    this.pageTotal =0;
                    this.cardBatchList =[];
                }
           }).catch((err)=>{
            this.vloading =false;
           })
        },
        // 流向
        flowLists(){
          let param = {
              objtype:'9'
          }
          Api.GET_FLOWLIST(param).then(res =>{
            if(res.data.status=="200"){
              this.flowList = res.data.data;
             }
          })
        },
        // 会员
        getMemberList(){
           Api.GET_MEMBERLIST().then(res =>{
             if(res.data.status=="200"){
              this.memberList = res.data.data;
             }
           })
        },
    },
    // ==================================== 生命周期 ====================================
    mounted () {
        this.getCardBatchList();
        // this.flowLists();
        // this.getMemberList();
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)

    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
.noData{
		height: 400px;
	}
.cardArticle{
    position: relative;
    padding: 20px;
    height: calc(100% - 169px);
}
/* S 检索 */
.simpleSearch{
    line-height: 40px;
    color: var(--main-color);
    cursor: pointer;
    white-space: nowrap;
}
.operateForm{
    margin-bottom: 10px;
}
.operateForm>>>.el-form-item{
    margin-bottom: 10px;
}
.none{
    display: none;
}
.block{
    display: block;
}
/* E 检索 */
/* S 表格 */
.total{
    line-height: 20px;
    font-weight: bold;
}
.total i{
    font-size: 20px;
    margin-right: 5px;
    vertical-align: text-bottom;
}
.serial em{
    display: block;
    margin-left: 26px;
}
.serialPop ul{
    -o-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    max-height: 120px;
    overflow-y: auto;
}
.serialPop ul li{
    color: #666;
    line-height: 28px;
}
.recordTable .el-dropdown-link{
    cursor: pointer;
    color: var(--main-color);
}
.recordTable>>>.el-table__fixed-right-patch{
    background-color: #F5F7FA;
}
.recordTable>>>td:nth-child(5) .cell{
    overflow: initial;
}
.recoverBtn,
.pauseBtn{
    cursor: pointer;
}
.recoverBtn:hover,
.pauseBtn:hover{
    color:var(--main-color);
}
/* E 表格 */
/* S 回收弹框 */
.recoverDlog>>>.el-dialog{
    width: 420px;
}
.recoverDlog>>>.el-dialog__footer{
    box-shadow: none;
    margin-bottom: 5px;
}
.recoverDlog>>>.el-button{
    padding: 8px 15px;
}
.recoverDlog p{
    color: #666;
    line-height: 25px;
}
.recoverDlog>>>.el-dialog__body{
    padding: 13px 20px 11px 20px;
}
.recoverDlog>>>.el-textarea{
    margin-top: 15px;
}
.pink{
    color: #F7615E;
    font-weight: bold;
    margin: 0 5px;
}
.el-icon-warning{
    color: #F2962C;
    font-size: 24px;
    margin-right: 15px;
}
.coverSuccess p{
    margin-bottom: 5px;
}
.coverSuccess em{
    display: block;
    line-height: 1.5;
}
/* E 回收弹框 */
.searchForm .selectIpt {position:relative; display: inline-block; border: 1px solid #DCDFE6; box-sizing: border-box; color: #606266; height: 40px; line-height: 40px; padding:0 30px 0 12px; border-radius:4px;cursor: pointer; min-width: 190px;}
.selectIpt > i { width:25px; line-height: 40px; padding:0 2.5px; color: #C0C4CC;}
.selectIpt > .iconright:before {font-size:16px;}
.selectIpt > .el-icon-circle-close:before {font-size:20px;}
.selectIpt .iconright {display: inline-block; position: absolute; right: 0; top:0;}
.selectIpt .el-icon-circle-close {display: none;position: absolute; right: 0; top:0;cursor: pointer;}
.selectIpt:hover .iconright {display: none;}
.selectIpt:hover .el-icon-circle-close {display: inline-block;}
</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/EjmdOrdersProcessed.vue